





import React, { useState, useEffect, useContext } from "react";
import tmdbApi from "../api/tmdbApi";
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
//  import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import { keyActivate } from "../utils/a11y";
import moment from "moment";
import OTPInput from "otp-input-react";
import { ToastContainer, toast } from 'react-toastify';
import SweetAlert from 'react-bootstrap-sweetalert';
let { lambda, country, appname } = window.app;
//  import * as Config from "../constants/Config";

//  import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";



const VerifyAccount = () => {
    const [pwd, setPwd] = useState('');
    const [email, setEmail] = useState("");
    const [newEmail, setNewEmail] = useState("");
    const [notFound, setNotFound] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [phone, setPhone] = useState("")
    const [phoneError, setPhoneError] = useState("")
    const [idc, setIdc] = useState("")
    const [toastType, setToastType] = useState("")
    const [toastMessage, setToastMessage] = useState("");
    //  const [success, setSuccess] = useState(false);
    //  const [config, setConfig] = useState({});
    const navigate = useNavigate();
    const [image, setImg] = useState(process.env.REACT_APP_IMAGE_CLOUD_FRONT);
    const [showSessionPopup, setShowSessionPopup] = useState(false);
    const [activeLoad, setActiveLoad] = useState("");
    const [otp, setOtp] = useState('');
    const [resendActive, setResendActive] = useState(false);
    const [otpclass, setOtpClass] = useState(false);
    const [countries, setCountries] = useState('');
    const [exist, setExist] = useState(false);
    const [verifiacationMethod, setVerificationMethod] = useState("");
    const [showEmailChange, setShowEmailChange] = useState(false);

    const { userData, setUserData, activeMenuObj, setActiveMenuObj, isRefreshed, setIsRefreshed, setBusinessData, setClientInfo, setSubscriberData, GetUserDataContext, activeMenuId, setActiveMenuId } = useContext(contentContext)

    // useEffect(() => {
    //     websitedefaults();
    // }, []);
    // const websitedefaults = async () => {
    //     try {
    //         console.log(tmdbApi);
    //         const response = await tmdbApi.websitedefaults();

    //         console.log(response);
    //     } catch {
    //         console.log("error");
    //     }
    // };
    const getclient = async () => {
        // GetTimeActivity(); // Assuming this is necessary

        try {
            const response = await tmdbApi.getClientUserData();

            if (response?.result?.length > 0) {

                const client = response.result[0]
                setUserData(client)
                // Make sure you're updating the context state properly
                if (client?.emailId) {
                    setEmail(client.emailId)
                    localStorage.setItem("emailid", client.emailId)
                }

            }
        } catch (error) {
            console.error("Error fetching client info:", error);
        }
    };
    const emailId = localStorage.getItem("emailid")
    const phoneNumber = localStorage.getItem("phone")

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
                if (window.site && window.site.admin && window.site.admin.verficationMethod) {
                    setVerificationMethod(window.site.admin.verficationMethod)
                }

            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)

        }
        if (window.site && window.site.admin && window.site.admin.verficationMethod) {
            setVerificationMethod(window.site.admin.verficationMethod)
        }

    }, [window.site]);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get("id");
    console.log('iddddddddddddddddddddddddddddd', id)
    useEffect(() => {
        GetCountries()
    }, []);

    useEffect(() => {
        if (id) {
            localStorage.setItem("clientid", id);
            // opened from the verification mail: there is no session yet, so the
            // context has no userData. Look the client user up by the id in the link.
            getclient();
        } else {
            setEmail(localStorage.getItem("emailid"))
        }

    }, [id])

    useEffect(() => {
        if (userData?.emailId) {
            setEmail(userData.emailId)
        }
    }, [userData?.emailId])

    const GetCountries = async () => {
        try {

            const response = await tmdbApi.getLookUp({
                "type": ["country"],
                "sortBy": "alpha3",
                // "projection": "tiny"
            });

            const countries = response?.result?.data || [];
            setCountries(countries);
            const usaCountry = countries.filter(
                eachItem => eachItem.countrycode.trim() === "(+1)" && eachItem.alpha2.trim() === "US"
            );

            // Print the filtered country in the console
            console.log("USA Country:", usaCountry);
            setIdc(usaCountry?.[0]?.alpha3)
            // console.log('responseresponseresponse',response?.result.data)
            // await axios({
            //     method: 'GET',
            //     url: "https://d4nv8o5tzs3mt.cloudfront.net/",
            // })
            //     .then(function (response2) {
            //         console.log('response2',response2)
            //       // let locData = JSON.stringify(response?.data)
            //       let temp = response2.data.headers['cloudfront-viewer-country'][0].value
            //       console.log('temp',temp)
            //       setDefaultCountryCode(temp)

            //       let k = response && response?.result && response?.result.data && response?.result.data.length>0 && response?.result.data.filter(eachItem=>eachItem.alpha2.trim()===temp)

            //       if (id===undefined) {
            //         setIdc(k[0].alpha3)
            //         let newUser = Object.assign({}, editUser);
            //         setEditUser({ ...newUser, ['idc']: k[0].alpha3 });
            //       }



            //     });

        } catch {
            console.log("error");
        }
    };

    useEffect(() => {
        if (toastMessage && toastType && toast[toastType]) {
            toast[toastType](toastMessage, {
                position: "bottom-center",
                // autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage && setToastMessage("");
        }
    }, [toastMessage, toastType]);
    //  const handleKeypress = (e) => {
    //      //it triggers by pressing the enter key

    //      if ((e.key === "Enter")) {
    //          setTimeout(function () {
    //              handleSignIn();
    //              console.log("called");
    //          }, 1000);
    //      }
    //  };

    //  const handleSignIn = (e) => {
    //      console.log("called1");
    //      if (email === "" && pwd === "") {
    //          setError("Please enter Email and Password");
    //          setTimeout(function () { setError("") }, 3000);
    //      }
    //      else if (email === "") {
    //          setError("Please enter Email");
    //          setTimeout(function () { setError("") }, 3000);
    //      }
    //      else if (pwd === "") {
    //          setError("Please enter Password");
    //          setTimeout(function () { setError("") }, 3000);
    //      }
    //      if (email && pwd) {
    //         //  setBtnLoader("loginpwd")
    //          loginPwd();
    //      }
    //  }

    const loginPwd = async () => {
        try {

            const response = await tmdbApi.signin({
                "emailid": email,
                "password": pwd,
                "useragent": JSON.parse(localStorage.getItem("loc"))
            });
            console.log(response);
            if (response?.statusCode === 200 && response?.result === "Invalid email or password") {
                setError(response?.result);
                setTimeout(function () { setError("") }, 3000);
                //  setBtnLoader("")
            } else if (response?.result === "Session Already Exists") {
                // signoutsession()
                setShowSessionPopup(true)
                //  setBtnLoader("")
            } else if (response?.statusCode === 200 && localStorage.getItem("check")) {
                localStorage.setItem("token", response?.result.token.token);
                localStorage.setItem("userId", response?.result.userid);
                GetUserDataSignIn();
                localStorage.setItem("loginTime", moment().format('DD-MMM-YYYY HH:mm:ss'))
                window.location.replace("/viewcontent/" + localStorage.getItem("check"));
                localStorage.removeItem("check");

            } else {
                localStorage.setItem("token", response?.result.token.token);
                localStorage.setItem("userId", response?.result.userid);
                GetUserDataSignIn();
                localStorage.setItem("loginTime", moment().format('DD-MMM-YYYY HH:mm:ss'))
                // navigate("/usermanagement");
            }


        } catch {
            console.log("error");
            //  setBtnLoader("")
            setError("Invalid email or password");
            setTimeout(function () { setError("") }, 3000);
        }
    };
    // console.log('userDatauserDatauserData', userData)
    const GetUserDataSignIn = async () => {
        try {

            const response = await tmdbApi.getUserData({});

            if (response?.statusCode === 200) {

                setUserData(response?.result?.[0]);
                localStorage.setItem("ClientName", response?.result?.[0]?.name)
                localStorage.setItem("ClientType", response?.result?.[0]?.type)
                let userArr = response?.result?.[0]?.permissions
                const EMAILID = response?.result?.[0]?.emailid
                console.log('user email', EMAILID)
                window.clarity("set", "orasi_user_email", EMAILID)
                // Clarity.addTag('Orasi User Email', EMAILID);
                const obj = userArr.reduce((acc, item) => {
                    if (item.submenus) acc[item.menu] = false;
                    return acc;
                }, {});
                // console.log('objjjjjjjj--->',obj)

                if (!(localStorage.getItem("check"))) {
                    let k = response?.result?.[0]

                    let permissionList = response && response?.result && response?.result?.[0] && response?.result?.[0]?.permissions
                    let filterdList = permissionList.filter((item) => item.display === true)
                    const data = filterdList?.filter((value) => value?.menu === "Dashboard")
                    let id = data && data[0] && data[0].menu.split(" ").join("").toLowerCase()

                    navigate("/" + id);
                    navigate("/users");


                    setActiveMenuId(data && data[0] && data[0].menuid)
                    console.log("activeMenuid------->", data)
                }

                // setActiveMenuObj(obj)
                //  setBtnLoader("")
                // console.log('response?.result?.[0] kkkkkkkkkk', response?.result?.[0])
            }
        } catch {
            //  setBtnLoader("")
            console.log("error");
        }
    };

    //  const forgotPassword = async () => {
    //      try {
    //         //  setBtnLoader("forgotpwd")
    //          const response = await tmdbApi.ForgotPassword({
    //              "emailid": email
    //          });
    //          console.log(response);
    //          if (response?.statusCode===200 && response?.result === "mail sent successfully") {
    //              setSuccess(true);
    //          } else if(response?.statusCode===200 && response?.result === "Email does not exists"){
    //              setError("Email Does Not Exists . Please Enter Valid Email");
    //              setTimeout(function () { setError("") }, 3000);
    //          }else {
    //              setError("Please Enter Email Id");
    //              setTimeout(function () { setError("") }, 3000);
    //          }
    //         //  setBtnLoader("")
    //      } catch {
    //          console.log("error");
    //         //  setBtnLoader("")
    //          setError("Please enter email id");
    //          setTimeout(function () { setError("") }, 3000);
    //      }
    //  };


    //  const handleForgot = (e) => {
    //      if(BtnLoader===""){
    //      forgotPassword();
    //      }
    //  }

    //  function onConfirm() {
    //      setSuccess(false);
    //  };

    //  const handleShowSessionPopup = () => {
    //      setShowSessionPopup(true)
    //  }
    const onCancel = () => {
        setShowSessionPopup(false)
        //  setBtnLoader("")
    }
    const signoutsession = async () => {
        try {
            //  setBtnLoader("sessionLoad")
            const response = await tmdbApi.SignOutUser({ emailId: email });
            console.log(response);
            if (response?.result === "Success") {
                loginPwd()
            } else {
                setError("Invalid Details");
                //  setBtnLoader("")
            }
        } catch {
            //  setBtnLoader("")
            console.log("error");
        }
    }

    //  const handleMessage = (e) => {
    //      setError("");
    //  }

    const handleResendOtp = async () => {
        setOtp("")
        setOtpClass(false)
        setResendActive(true)
        setTimeout(function () {
            setResendActive(false)
        }, 3000)
        // setOtpClass(true)
        try {
            let payload = {};
            //   console.log(tmdbApi);
            if (verifiacationMethod === "phone" && id === null) {
                payload = {
                    phone: phoneNumber,

                };
            } else {
                payload = {
                    emailId: email || localStorage.getItem("emailid"),

                };
            }
            const response = await tmdbApi.resendMail(

                payload

            );
            // setResendActive(false)
            console.log(response);
        } catch {
            setResendActive(false)

            console.log("error");
        }
    };
    //   const handleOtpError = (e) => {
    //     console.log("came");
    // setOtpClass(false)
    //   }
    const handleClose = () => {
        navigate("/")
    }
    // const handleRequest = async () => {
    //     if (otp === "") {
    //       setOtpClass(true);
    //       return;
    //     }

    //     setActiveLoad("verify");

    //     try {
    //       // Prepare the request payload
    //       let payload = {};

    //       if (verifiacationMethod === "phone" && id===null) {
    //         payload = {
    //           phone: phoneNumber,
    //           otp: Number(otp),
    //         };
    //       } else {
    //         payload = {
    //           emailid: emailId ?? userData?.emailId,
    //           otp: Number(otp),
    //         };
    //       }

    //       // Make the API call
    //       const response = await tmdbApi.otpVerify(payload);

    //       // Check the API response
    //       if (response?.result === "Invalid code entered") {
    //         setActiveLoad("");
    //         setOtpClass(true); // Handle invalid OTP
    //       } else if(response?.result ==="Client not found"){
    //         setActiveLoad("");
    //         setToastMessage("Client not found")
    //         setToastType("warning");
    //       }else if(response?.result ==="Invalid Phone Number"){
    //         setToastMessage("Invalid Phone Number")
    //         setToastType("warning");
    //       }   else {

    //         setActiveLoad("");
    //         if(id){
    //             GetUserDataContext()
    //             navigate("/thankyou"); // Navigate to the thank you page
    //         }else{
    //             navigate("/thankyou");
    //         }


    //       }

    //       console.log(response); // Log the response for debugging
    //     } catch (error) {
    //       setResendActive(false); // Reset resend active state
    //       console.error("Error during OTP verification:", error);
    //       setActiveLoad("");
    //     }
    //   };
    const handleRequest = async () => {
        if (otp === "") {
            //   setOtpClass(true);
            return;
        }

        const isPhoneFlow = verifiacationMethod === "phone" && id === null;
        const emailid = email || localStorage.getItem("emailid");

        // the mail link opens a fresh session, so bail out instead of posting an
        // otpVerify without an identifier (the api answers "Client not found")
        if (!isPhoneFlow && !emailid) {
            setToastMessage("Unable to verify. Please open the link again or use Resend.");
            setToastType("warning");
            return;
        }

        setActiveLoad("verify");

        try {
            let payload = {};

            if (isPhoneFlow) {
                payload = {
                    phone: phoneNumber,
                    otp: Number(otp),
                };
            } else {
                payload = {
                    emailid: emailid,
                    otp: Number(otp),
                };
            }
console.log('payloadherere',payload);
            const response = await tmdbApi.otpVerify(payload);

            if (response?.result === "Invalid code entered") {
                setActiveLoad("");
                setOtpClass(true);
            } else if (response?.result === "Client not found") {
                setActiveLoad("");
                setToastMessage("Client not found");
                setToastType("warning");
            } else if (response?.result === "Invalid Phone Number") {
                setActiveLoad("");
                setToastMessage("Invalid Phone Number");
                setToastType("warning");
            } else if (response?.result === "Invalid Email") {
                setActiveLoad("");
                setToastMessage("Invalid Email");
                setToastType("warning");
            } else {
                if (id) {
                    getclient();
                }

                setActiveLoad("");
                navigate("/thankyou");



            }

            //   console.log(response); 
        } catch (error) {
            setResendActive(false);
            setActiveLoad("");
            console.error("Error during OTP verification:", error);
        }
    };

    const handlechangeVerify = () => {
        setShowEmailChange(true)
    }
    const emailValidation = (e) => {
        let flag = true;
        const regEx = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}(.[a-zA-Z{2,8}])?/g;
        if (regEx.test(newEmail)) {
            setError("");

        } else if (!regEx.test(newEmail) && newEmail !== "") {
            setError("Email is Not Valid");
            setTimeout(function () { setError("") }, 3000);
            flag = false;
        }
        if (newEmail === "") {
            setError("Please Enter Email");
            setTimeout(function () { setError("") }, 3000);
            flag = false;
        }
        return flag

    }
    const phoneValidation = (e) => {
        let flag = true;

        if (phone === "") {
            setPhoneError("Please Enter Phone");
            setTimeout(function () { setPhoneError("") }, 3000);
            flag = false;
        } else if (
            (idc?.trim() === "USA" && !/^\(\d{3}\) \d{3}-\d{4}$/.test(phone)) ||
            (idc.trim() === "IND" && !/^\d{5}-\d{5}$/.test(phone))
        ) {
            setPhoneError("Invalid phone number format");
            setTimeout(function () { setPhoneError("") }, 3000);

            flag = false;
            // formIsValid = false;
        }
        return flag

    }
    console.log("idcccccccccccccccccccccccccccccccc", idc)
    const handlePhoneChange = (event) => {
        const { name, value } = event.target;
        console.log("nameeeeeeeeeeeeeeeeeeeeeeeeeee", name)
        console.log("valueeeeeeeeeeeeeeeeeeeeeeeeee", value)
        if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = idc?.trim(); // Directly get the latest idc value
            console.log("currentIdcccccccccccccccccccccccccccccccc", currentIdc)
            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }
            setPhoneError("")
            // Update the phone number only
            setPhone(formattedValue)

        }

    }
    //  const handleChangeEmail=()=>{
    //    setNewEmail("")
    //    setShowEmailChange(true)
    //  }
    const handleCountryChange = (e) => {
        const newCountry = e.target.value;
        // setIdc(newCountry); // Update state
        setPhone("")
        setIdc(newCountry);

    };
    const handleClosePopup = () => {
        setNewEmail("")
        setPhone("")
        setIdc(" USA")
        setShowEmailChange(false)
    }
    const handleEmailchange = (e) => {
        setNewEmail(e.target.value)
    }
    const handleCancel = () => {
        setShowEmailChange(false)
        setNewEmail("")
        setIdc(" USA")
        setPhone("")
    }
    const handleSave = async () => {
        const validate = emailValidation()
        const phoneValidate = phoneValidation()
        if (validate || phoneValidate) {
            setActiveLoad("save")
            let response
            try {

                if (verifiacationMethod === "phone" && id === null) {
                    response = await tmdbApi.ChangePhone({
                        "oldphone": phoneNumber,
                        "newphone": phone,
                        "idc": idc
                    });

                } else {
                    response = await tmdbApi.ChangeEmail({
                        "oldemailid": email,
                        "newemailid": newEmail
                    });
                }

                console.log(response);
                if (response?.result === "Email Sent Successfully") {
                    setEmail(newEmail)
                    localStorage.setItem("emailid", newEmail)
                    setActiveLoad("")
                    setShowEmailChange(false)
                    // setBtnLoader(false)
                    // setExist(true)
                    //    setSuccess(true)
                    setToastMessage("Email Sent Successfully")
                    setToastType("success");
                    setPhone("")
                    setNewEmail("")
                    //    setEmail("")

                } else if (response?.result === "Client Not Found") {
                    setActiveLoad("")
                    setShowEmailChange(false)
                    setToastMessage("Client Not Found")
                    setToastType("warning");
                    //    setNotFound(true)
                    // setBtnLoader(false)
                    setPhone("")
                    setNewEmail("")
                    //    setEmail("")
                    // setSendEmail(true)
                } else if (response?.result === "Email Already Exists") {
                    setActiveLoad("")
                    setShowEmailChange(false)
                    //    setExist(true)
                    setToastMessage("Email Already Exists")
                    setToastType("warning");
                    setPhone("")
                    setNewEmail("")
                    //    setEmail("")
                } else if (response?.result === "Phone Number Already Exists") {
                    setActiveLoad("")
                    setShowEmailChange(false)

                    setToastMessage("Phone Number Already Exists")
                    setToastType("warning");
                    setPhone("")
                    setNewEmail("")
                    // setEmail("")
                } else if (response?.result === "SMS sent successfully") {


                    localStorage.setItem("phone", phone)
                    setActiveLoad("")
                    setShowEmailChange(false)
                    setPhone("")
                    setIdc(" USA")
                    setNewEmail("")

                }
                // else if (response?.result==="PENDING APPROVAL"){
                //     setBtnLoader(false)
                // //    setAlertMsg(true)
                // navigate("/thankyou")
                // }  else {
                //     setBtnLoader(false)
                //     navigate("/verifyaccount")
                // }
            } catch {
                console.log("error");
                setActiveLoad("")
                setError("Invalid email or password");
                setPhone("")
                setNewEmail("")
                setTimeout(function () { setError("") }, 3000);
            }
            console.log("savedddddddddddddddddddddddddddddd")
        }
    }
    const onConfirm = () => {
        setSuccess(false)
    }
    const onConfirm1 = () => {
        setNotFound(false)
    }
    const onExist = () => {
        setExist(false)
    }
    const handleChange = (otp) => {
        setOtp(otp)
        setOtpClass(false);
    }
    return (
        <>
            <Modal className="access-denied" show={showSessionPopup}>
                <div className="modal-body enquiry-form">
                    <div className="container">
                        <button
                            className="close-btn"
                            onClick={e => onCancel()}
                            id="access-denied-close-btn"
                        >
                            <span className="material-icons">close</span>
                        </button>
                        <span className="material-icons access-denied-icon" id="access-denied-icon">
                            web_asset_off
                        </span>
                        <h3 id="multiple-sessions-title">Multiple Sessions Found</h3>
                        <p id="multiple-sessions-text">
                            Another session is running in another browser. Do you want to terminate that session?
                        </p>
                        <div className="popup-footer">
                            <button
                                className="fill_btn yellow-gradient"
                                data-bs-toggle="modal"
                                data-bs-target="#recommendModal"
                                onClick={e => signoutsession()}
                                id="yes-terminate-session"
                            >
                                Yes
                            </button>
                            <button
                                className="fill_btn"
                                data-bs-toggle="modal"
                                data-bs-target="#recommendModal"
                                onClick={e => onCancel()}
                                id="no-terminate-session"
                            >
                                No
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            <>
                <div className="signin-wrapper" id="signin-wrapper">
                    <div className="logo_section" id="logo-section">
                        <img
                            src={`${image}${appname}/images/web/logo-dark.png`}
                            className="logo"
                            id="signin-logo"
                        />
                        <button className="close-btn" onClick={handleClose} id="signin-close-btn">
                            <span className="material-icons">close</span>
                        </button>
                    </div>
                    <div className="signin-body" id="signin-body">
                        <div className="signin-graphic" id="signin-graphic">
                            <img
                                src={`${image}${appname}/images/web/Log-in-graphic.svg`}
                                id="signin-graphic-img"
                            />
                            <h3 id="onboarding-title">Seamless Onboarding</h3>
                            <p id="onboarding-subtitle">Successful Beginnings: Your Journey Starts Here!</p>
                        </div>

                        <div className="signin-section emaillogin verifying-account" id="verify-account-section">
                            <div className="d-flex">
                                <div>
                                    <h1 className="bold-heading" id="verify-account-heading">Verify Your account</h1>
                                    <p className="mb-3" id="verify-account-text"> {`Enter the 5-digit OTP sent to your ${verifiacationMethod === "phone" && id === null ? "Mobile" : "Email"}`}


                                    </p>
                                    {/* <p> Otp has been sent to: <span className="email-style">{emailId}</span></p> */}
                                </div>

                            </div>

                            <div className="mb-0 d-flex change-section" id="phone-number-section">
                                <p>
                                    {verifiacationMethod === "phone" && id === null ? <span className="material-symbols-outlined">call</span> : <span className="material-symbols-outlined">
                                        mail
                                    </span>}

                                </p>
                                <p className="ps-2" id="phone-number-text">{verifiacationMethod === "phone" && id === null ? phoneNumber : (email)}
                                </p>
                                <a className="change-txt" id="change-phone-link" onClick={handlechangeVerify} onKeyDown={keyActivate(handlechangeVerify)}>
                                    Change
                                </a>

                                {/* <div className="modal fade" id="phonechangemodal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                           <div className="modal-dialog phonemodal">
                               <div className="modal-content">
                                   <div className="modal-header header-style">
                                       <h5 className="modal-title" id="exampleModalLabel">Edit</h5>
                                       <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                                           <span className="material-symbols-outlined">close</span>
                                       </button>
                                   </div>
                                   <div className="modal-body">
                                       <p className="mb-3">Change Phone Number</p>
                                       <input type="text" className="form-control" placeholder="9653284598" id="phone-change-input" />
                                       <div className="signin-footer mt-2">
                                           <button className="outline_btn mx-2" id="cancel-phone-change">Cancel</button>
                                           <button className="fill-btn" id="save-phone-change">SAVE & SEND OTP</button>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div> */}
                            </div>

                            <div className="otp-blocks mt-5 mb-5" id="signup-otp-blocks">
                                <div className={otpclass ? "otp-inputs block-margin signup-otp-inputs invalid errorStyle" : "otp-inputs block-margin"} id="signup-otp-inputs">
                                    <OTPInput
                                        className="mb-2"
                                        value={otp}
                                        onChange={handleChange}
                                        autoFocus
                                        OTPLength={5}
                                        otpType="number"
                                        onFocus={() => console.log("Focused!")}
                                        id="otp-input-field"
                                    />
                                    {otp === "" ? (
                                        <p id="otp-empty-error">Please enter valid otp</p>
                                    ) : (
                                        <p id="otp-error">The OTP you have entered is incorrect. Please try again or request a new OTP</p>
                                    )}
                                </div>

                                <button className="resend-button" onClick={handleResendOtp} id="resend-otp-button">
                                    Resend
                                </button>
                                {resendActive ? (
                                    <p
                                        style={{
                                            'font-size': '12px',
                                            'color': 'green',
                                            'position': 'absolute',
                                            'left': '80px',
                                            'bottom': '-29%',
                                        }}
                                        id="otp-resend-msg"
                                    >
                                        OTP Resent!
                                    </p>
                                ) : null}
                            </div>





                            <div className="signin-footer mt-2" id="signin-footer">
                                <button className="fill-btn" onClick={handleRequest} id="verify-btn" disabled={activeLoad === "verify"}>
                                    {activeLoad === "verify" ? (
                                        <img
                                            src={`${image}${appname}/images/web/rotate_right.svg`}
                                            className="loading-icon"
                                        />
                                    ) : null}
                                    VERIFY
                                </button>
                            </div>
                            <span className="errormsg" id="error-msg"></span>
                        </div>
                        <Modal
                            className="modal fade change-email"
                            show={showEmailChange}

                        >

                            <div className="modal-dialog phonemodal">
                                <div className="modal-content">
                                    <div className="modal-header header-style">
                                        <h5 className="modal-title" id="exampleModalLabel">Edit</h5>
                                        <button type="button" className="close" onClick={handleClosePopup}>
                                            <span className="material-symbols-outlined">close</span>
                                        </button>


                                    </div>
                                    <div className="modal-body">
                                        <p className="mb-3">{verifiacationMethod === "phone" && id === null ? "Change Phone" : "Change Email"}</p>
                                        {verifiacationMethod === "phone" && id === null ? <>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <div className="input-group-text">
                                                        <span className="material-symbols-outlined">call</span>
                                                    </div>
                                                </div>
                                                <select name="idc" className="colorselect capitalize"
                                                    onChange={handleCountryChange} value={idc}>
                                                    {countries && countries?.length > 0 && countries?.map((task, i) => {
                                                        return (
                                                            <><option key={i} value={task.alpha3}>{task.alpha3}{task.countrycode}</option></>
                                                        )
                                                    }
                                                    )}
                                                </select>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter phone"
                                                    name="phone"
                                                    value={phone}
                                                    id="email-change-input"
                                                    onChange={handlePhoneChange}

                                                />
                                            </div>

                                        </> :
                                            <input type="text" className="form-control" placeholder={"Enter email"} name="newemail" value={newEmail} id="email-change-input" onChange={handleEmailchange} />
                                        }



                                        {verifiacationMethod === "phone" && id === null ? (
                                            phoneError ? (
                                                <span
                                                    className="errormsg-floating"
                                                    style={{ fontWeight: 'bold', color: 'red' }}
                                                    id="defaultError"
                                                >
                                                    {phoneError}
                                                </span>
                                            ) : null
                                        ) : error ? (
                                            <span
                                                className="errormsg-floating"
                                                style={{ fontWeight: 'bold', color: 'red' }}
                                                id="defaultError"
                                            >
                                                {error}
                                            </span>
                                        ) : null}

                                        <div className="signin-footer mt-2">
                                            <button className="outline_btn mx-2" id="cancel-email-change" onClick={handleCancel}>Cancel</button>
                                            <button className="fill-btn" id="save-email-change" onClick={handleSave} disable={activeLoad === "save"}> {activeLoad === "save" ? (
                                                <img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" id="otpLoadingIcon" />
                                            ) : null}SAVE & SEND OTP</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                        <SweetAlert show={success}
                            custom
                            confirmBtnText="Ok"
                            confirmBtnBsStyle="primary"
                            title={"Otp Sent Successfully"}
                            onConfirm={e => onConfirm()}
                        >
                        </SweetAlert>
                        <SweetAlert show={notFound}
                            custom
                            confirmBtnText="Ok"
                            confirmBtnBsStyle="primary"
                            title={"Client Not Found"}
                            onConfirm={e => onConfirm1()}
                        >
                        </SweetAlert>
                        <SweetAlert show={exist}
                            custom
                            confirmBtnText="Ok"
                            confirmBtnBsStyle="primary"
                            title={"Email Already Exists"}
                            onConfirm={e => onExist()}
                        >
                        </SweetAlert>
                    </div>

                </div>
                <footer className="login_footer" id="login-footer">
                    <div className="container-fluid">
                        <p className="footer-para" id="footer-text">
                            © {new Date().getFullYear()} SpotSaver. All rights reserved.
                        </p>
                    </div>
                </footer>
            </>
            <ToastContainer
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
                id="toastContainer"
            />


        </>
    );

};

export default VerifyAccount;
